import { render } from "./editOrderRequest.vue?vue&type=template&id=61da7f64"
import script from "./editOrderRequest.vue?vue&type=script&lang=js"
export * from "./editOrderRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__